export default __webpack_public_path__ + "media/src/assets/images/divisions-e776a78d2d2e7b201f1d5ee55f1442b6.png";